import { CheckNotes, InspectionCase } from './inspection-case.dto';

export class InspectionCapacityCaseDto extends InspectionCase {
  volume?: number = 0; // liter
}
export class InspectionCapacityCase extends InspectionCapacityCaseDto {
  constructor(data: InspectionCapacityCaseDto = {}) {
    super(data);
    this.volume = data.volume;
  }

  getNotes?(): CheckNotes[] {
    const notes = super.getNotes();

    // if (notes[0]) {
    //   notes[0].notes = notes[0]?.notes?.replace('0L', `${this.volume}L`);
    // }

    return notes;
  }
}
